import { useFlowStore } from '@/store/flowStore'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const ChatRoute = lazyRouteComponent(() => import('@/features/chat/Chat'), 'Chat')

export const Route = createFileRoute('/chat')({
  component: ChatRoute,
  beforeLoad: () => {
    const { selectedObjectives } = useFlowStore.getState()
    if (selectedObjectives.length === 0) {
      throw redirect({ to: '/objetivo' })
    }
  },
})
